<template>
  <div id="app" v-cloak>
     <router-view/>
     <!-- loading 效果 -->
    <div v-if="showLoading" style="
          position: fixed;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          z-index: 9999999999;
          display: table;
        ">
      <div style="display: table-cell; vertical-align: middle; text-align: center">
        <img src="./assets/login/loading.gif" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.state.showLoading = false;
  },
  computed: {
    showLoading () {
      return this.$store.state.showLoading || false;
    },
  },
}
</script>

<style scoped>
#app {
 background: #F8F8F8;
 overflow: auto;
}
</style>
